import { QuizPreviewPageController } from './quiz-preview-page.controller';
import { QuizPreviewPageProps } from './quiz-preview-page.model';

export const QuizPreviewPage = (props: QuizPreviewPageProps) => {
  return <QuizPreviewPageController {...props} />;
};
